import { ReactNode } from 'react';
import { PlatformLoader } from '@flexinet/ui-components';
import { useUserAccount } from '../../../../hooks/useUserAccount';
import { BillingSetupCard } from './BillingSetupCard';

export const RequireBillingCustomer = ({ children }: { children: ReactNode }) => {
    const { userAccount } = useUserAccount();

    if (!userAccount) {
        return <PlatformLoader message="Loading account..." />;
    }

    if (!userAccount.customerId) {
        return <BillingSetupCard variant="full" />;
    }

    return children;
};
